// extracted by mini-css-extract-plugin
export default {"container":"form-block_container__kmouR","inner":"form-block_inner__pgv-o"};